module.exports = __webpack_public_path__ + "static/media/top-img_16.953c12cf.png";